import React, {useContext, useEffect, useState} from 'react';
import {Dropdown, Form, Spinner} from "react-bootstrap";
import {createLanguage, createPrice, fetchLanguages, fetchPrices} from "../../../http/bookAPI";
import Modal from "react-bootstrap/Modal";
import {Context} from "../../../index";
import {observer} from "mobx-react-lite";

const CreatePrice = observer(({ show, handleClose }) => {
    const {book} = useContext(Context);

    const [price_value, setPriceValue] = useState('');

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchPrices().then(data => book.setPrices(data))
    }, []);

    const addPrice = async () => {
        setLoading(true);
        setError('');
        try {
            await createPrice({ price: price_value });
            const updatedPrices = await fetchPrices(); // Обновляем список жанров после изменения
            book.setPrices(updatedPrices);
            book.setSelectedPrice({}); // Сбрасываем выбранный жанр
            setPriceValue(''); // Очищаем поле ввода
            handleClose(); // Закрываем модальное окно
        } catch (e) {
            const errorMessage = e.response?.data?.message || 'An error occurred while adding the genre.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={() => { setError(''); handleClose(); }} centered>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Add a new Price:</h1>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                    ></button>
                </div>



                <div className="modal-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <Form>
                        <Form.Control
                            value={price_value}
                            onChange={e => setPriceValue(e.target.value)}
                            placeholder="Enter new Price"
                            disabled={loading}
                        />
                    </Form>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                        disabled={loading}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={addPrice}
                        disabled={!price_value.trim() || loading}
                    >
                        {loading ? <Spinner as="span" animation="border" size="sm"/> : 'Add in DB'}
                    </button>

                </div>
            </div>
        </Modal>
    );
});


export default CreatePrice;